import { GetRecipeCostRequest, GetRecipeCostsRequest, RecipeCost, RecipeCostHeader, ServiceResult } from '../models';
import ApiService from './api-service';

class RecipeCostService extends ApiService {
  private static classInstance: RecipeCostService;
  private recipeCostController: AbortController;

  private constructor() {
    super('RecipeCost');
    this.recipeCostController = new AbortController();
  }

  public static getInstance(): RecipeCostService {
    if (!this.classInstance) {
      this.classInstance = new RecipeCostService();
    }
    return this.classInstance;
  }

  public abortGetRecipeCost = (): void => {
    this.recipeCostController.abort();
  };
  public getRecipeCost(request: GetRecipeCostRequest): ServiceResult<RecipeCost> {
    this.recipeCostController = new AbortController();
    return this.post(`${this.baseUrl}/GetRecipeCost`, request, undefined, this.recipeCostController.signal);
  }
  public getRecipeCosts(request: GetRecipeCostsRequest): ServiceResult<RecipeCostHeader[]> {
    this.recipeCostController = new AbortController();
    return this.post(`${this.baseUrl}/GetRecipeCosts`, request, undefined, this.recipeCostController.signal);
  }
}

export default RecipeCostService;
